/// <reference path="../typings/tsd.d.ts" />
'use strict';

var Reducer_1 = require('./Reducer');
exports.Devtool = Reducer_1['default'];
var Component_1 = require('./Component');
exports.Component = Component_1['default'];
var Middleware_1 = require('./Middleware');
exports.stateHistoryTracker = Middleware_1['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-state-history/lib/index.js
 ** module id = 1703
 ** module chunks = 0
 **/